import { FormGroup } from '@blueprintjs/core'
import classNames from 'classnames'
import React, { SFC } from 'react'

import { PureSelect } from 'modules/forms'

import { isPresent } from '../../app/shared'
import { SyncIndicator } from './sync-indicator'
import { FieldAdapterProps, SelectProps } from './types'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

type OwnProps = {
  shouldTranslateOptions?: boolean
  compact?: boolean
}

export type Props = FieldAdapterProps<SelectProps> & OwnProps

const SelectAdapter: SFC<Props> = ({
  disabled = false,
  fill = true,
  compact = false,
  label,
  meta,
  helperText,
  intent,
  inline,
  input,
  required,
  items,
  hideNoSelectedOption,
  noSelectedOptionText,
  enableSyncControl,
  prefixText,
  suffixText,
  // tslint:disable-next-line:no-empty
  onSyncChange = (fieldName: string, newValue: boolean) => {},
  translate = identity,
  shouldTranslateOptions = false,
  ...rest
}) => {
  const { id, labelText } = createLabelWithId(input, label)
  const intentType = getIntent(meta, intent)
  const helperTextMessage = createHelperText(meta, helperText, translate)
  const labelInfo = createRequiredLabel(required, translate)

  // TODO: Needs to be refactored => change to trigger for validate after sync change
  const handleSyncChange = (fieldName: string, newValue: boolean) => {
    onSyncChange(fieldName, newValue)
    const value = input.value
    input.onChange(' ') // trigger for validate
    window.setTimeout(() => input.onChange(value))
  }

  const reqLabelMod = (
    <>
      {labelInfo}
      {enableSyncControl && (
        <SyncIndicator
          translate={translate}
          fieldName={input.name}
          disabled={disabled}
          onSyncChange={handleSyncChange}
        />
      )}
    </>
  )

  const formGroupClassName = classNames({
    required: isPresent(labelInfo),
    'has-prefix-text': isPresent(prefixText),
    'has-suffix-text': isPresent(suffixText),
    'bp3-compact': compact,
  })

  const pureSelectClassName = classNames({
    'bp3-fill': fill,
  })

  return (
    <FormGroup
      className={formGroupClassName}
      helperText={helperTextMessage}
      label={isPresent(prefixText) ? undefined : labelText}
      labelFor={id}
      labelInfo={reqLabelMod}
      intent={intentType}
      inline={inline}
      disabled={disabled}
    >
      {prefixText && <div className="bp3-input-prefix">{prefixText}</div>}
      <PureSelect
        className={pureSelectClassName}
        id={id}
        disabled={disabled}
        name={input.name}
        items={items}
        onChange={input.onChange}
        initialValue={input.value}
        hideNoSelectedOption={hideNoSelectedOption}
        translate={translate}
        noSelectedOptionText={noSelectedOptionText}
        shouldTranslateOptions={shouldTranslateOptions}
      />
      {suffixText && <div className="bp3-input-suffix">{suffixText}</div>}
    </FormGroup>
  )
}

export { SelectAdapter }



// WEBPACK FOOTER //
// ./src/modules/forms/select-adapter.tsx